import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { servicesOfferedLabels } from "@components/entity/constants";
import type { ApplyCoaTemplateEntitySelectionRow } from "../applyCoaTemplateEntitySelection.types";

export const ApplyCoaEntityServicesCell = memo(
    ({
        row,
    }: CellContext<
        ViewTableFeatures,
        ApplyCoaTemplateEntitySelectionRow,
        unknown
    >) => {
        if (row.original.isClientRow) {
            return <ViewTableCell />;
        }

        const services = row.original.services ?? [];
        const label =
            services.length === 0
                ? "-"
                : services
                      .map(
                          (service) =>
                              servicesOfferedLabels[service] ?? service,
                      )
                      .join(", ");

        return (
            <ViewTableCell>
                <span className="text-secondary">{label}</span>
            </ViewTableCell>
        );
    },
);
